module.exports = __webpack_public_path__ + "img/jg_tag.5152c0bd.png";